import { Component, input, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FadingSpanComponent } from '../fading-span/fading-span.component';

@Component({
    selector: 'web-ratio-bar',
    templateUrl: './ratio-bar.component.html',
    styleUrls: ['./ratio-bar.component.scss'],
    imports: [TranslateModule, FadingSpanComponent],
})
export class RatioBarComponent {
    private translateService = inject(TranslateService);

    public title = input(this.translateService.instant('GLOBAL.SELF_RELIANCE'));
    public value = input(0, { transform: (value: number) => (value > 100 ? 100 : value < 0 ? 0 : value) });

    public showBar = input(true);
    public showIcon = input(false);
    public autorizeZero = input(false);
}
